import { MutationTree } from "vuex";

import { AutomationState } from "../types";

const mutations: MutationTree<AutomationState> = {
  setEnabled(state, enabled) {
    state.enabled = enabled;
  },
  setEnabledReview(state, enabledReview) {
    state.enabledReview = enabledReview;
  },
  setThreshold(state, threshold) {
    state.threshold = threshold;
  },
  setThresholdFacial(state, thresholdFacial) {
    state.thresholdFacial = thresholdFacial;
  },
  setRetentionDays(state, retentionDays) {
    state.retentionDays = retentionDays;
  },
};

export default mutations;
